import { create } from 'zustand';
import { combine } from 'zustand/middleware';

interface LivePlayerSettingsState {
  pinLivePlayer: boolean;
  stationId: string | null; // Station ID for the live player, null means use active station
  stationClock: Date | null; // Clock value for the active station
  isPiPActive: boolean; // True when the live player is in Picture-in-Picture mode
  isFullscreen: boolean; // True when the live player is shown in fullscreen overlay
}

/**
 * Zustand store for managing live player settings.
 * Controls whether the live player is pinned (shown across navigation).
 */
export const useLivePlayerSettingsStore = create(
  combine(
    {
      pinLivePlayer: true,
      stationId: null,
      stationClock: null,
      isPiPActive: false,
      isFullscreen: false,
    } as LivePlayerSettingsState,
    (set) => ({
      setStationId: (stationId: string | null) => {
        set({
          stationId: stationId ?? null,
          stationClock: null,
        });
      },

      close: () => {
        set({
          stationId: null,
        });
      },

      setIsPiPActive: (value: boolean) => {
        set({ isPiPActive: value });
      },

      setIsFullscreen: (value: boolean) => {
        set({ isFullscreen: value });
      },

      /** Sets whether the live player is pinned (shown across navigation). */
      setPinLivePlayer: (value: boolean) => {
        set({ pinLivePlayer: value });
      },

      // Update clock value for the active station
      setStationClock: (clock: Date) => {
        set({
          stationClock: clock,
        });
      },
    }),
  ),
);
